import { g as getLocale, t as trackMessageCall } from "./runtime.js";
const en_sign_in = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Sign in`;
  }
);
const de_sign_in = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Anmelden`;
  }
);
const sp_sign_in = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Iniciar sesión`;
  }
);
const sign_in = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("sign_in", locale);
  if (locale === "en") return en_sign_in();
  if (locale === "de") return de_sign_in();
  return sp_sign_in();
};
const en_email = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `e-mail`;
  }
);
const de_email = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `E-Mail`;
  }
);
const sp_email = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Correo electrónico`;
  }
);
const email = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("email", locale);
  if (locale === "en") return en_email();
  if (locale === "de") return de_email();
  return sp_email();
};
const en_email_info = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `We will send you an e-mail with a key`;
  }
);
const de_email_info = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Wir senden Dir eine E-Mail zur Verifizierung`;
  }
);
const sp_email_info = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Te enviaremos un correo electrónico para la verificación`;
  }
);
const email_info = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("email_info", locale);
  if (locale === "en") return en_email_info();
  if (locale === "de") return de_email_info();
  return sp_email_info();
};
const en_send_verification = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Send verification mail`;
  }
);
const de_send_verification = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Verifizierungs-Mail senden`;
  }
);
const sp_send_verification = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Enviar correo de verificación`;
  }
);
const send_verification = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("send_verification", locale);
  if (locale === "en") return en_send_verification();
  if (locale === "de") return de_send_verification();
  return sp_send_verification();
};
export {
  email_info as a,
  sign_in as b,
  email as e,
  send_verification as s
};
